// extracted by css-extract-rspack-plugin
export default {"root":"TK_T7n"};